export const listFormSplitDefault = [60,40]

